import { validationMessage } from 'vuelidate-messages'
import { messages, isDateValid, isDateBeforeMaxDate } from '@/lib/validation-helpers'
import { required, maxLength, requiredIf } from 'vuelidate/lib/validators'

export const validations = {
  validations: {
    data: {
      product_id: {
        required
      },
      start_date: {
        required
      },
      end_date: {
        required: requiredIf(data => !data.one_time_purchase)
      },
      name_reference: {
        maxLength: maxLength(64)
      },
      owner_id: {
        required
      },
      cancellation_deadline: {
        isDateValid(val) {
          return isDateValid.call(this, val)
        },
        isDateBeforeMaxDate(val, data) {
          return isDateBeforeMaxDate.call(this, val, data.start_date)
        }
      },
      currency: {
        required,
        maxLength: maxLength(3)
      }
    }
  },

  methods: {
    $v_displayMessage: validationMessage(messages)
  }
}
